/**
 * @generated SignedSource<<4ccd29922f98ed6df872df40aa7c186d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassCategory = "HIDDEN" | "ICON" | "%future added value";
export type ClassCategoriesUserHiddenClassesQuery$variables = {
  publicUserId: string;
  skip?: boolean | null | undefined;
};
export type ClassCategoriesUserHiddenClassesQuery$data = {
  readonly userByPublicUserId?: {
    readonly userClassCategories: ReadonlyArray<{
      readonly category: ClassCategory;
      readonly classId: string;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ClassCategoriesUserHiddenClassesQuery = {
  response: ClassCategoriesUserHiddenClassesQuery$data;
  variables: ClassCategoriesUserHiddenClassesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "publicUserId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "publicUserId",
    "variableName": "publicUserId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassCategoriesUserHiddenClassesQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "userByPublicUserId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserClassCategoryNode",
                "kind": "LinkedField",
                "name": "userClassCategories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassCategoriesUserHiddenClassesQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "userByPublicUserId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserClassCategoryNode",
                "kind": "LinkedField",
                "name": "userClassCategories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4ab900be492dd07f559b613492d87148",
    "id": null,
    "metadata": {},
    "name": "ClassCategoriesUserHiddenClassesQuery",
    "operationKind": "query",
    "text": "query ClassCategoriesUserHiddenClassesQuery(\n  $publicUserId: String!\n  $skip: Boolean = false\n) {\n  userByPublicUserId(publicUserId: $publicUserId) @skip(if: $skip) {\n    userClassCategories {\n      classId\n      category\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "665d546dc8bd33cc12d5d7a66677c8d7";

export default node;
